import { useContext, useEffect, useState } from 'react';
import ModalWithButton from 'components/reusable/modal-with-button';
import {
  useFeatureFlags,
  ExperimentFlag,
} from 'context-providers/feature-flag-provider';
import { LocationContext } from 'context-providers/location-provider';
import styled from 'styled-components';
import { trackButtonEvent } from 'lib/analytics';
import { countryInfoMap } from 'entities/country-info-map';
import Link from 'next/link';

const Header = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
`;
const SubtextHeader = styled.div`
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  text-align: left;
`;
const SubtextList = styled.ul`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  list-style-type: disc;
  padding-left: 20px;
  margin-top: 16px;
  li::marker {
    color: var(--text-secondary);
  }
`;

const InternationalCurrencyModalSubtext = () => {
  const { countryCode } = useContext(LocationContext);
  const countryInfo = countryInfoMap[countryCode];

  const countryName = countryInfo?.name || 'a country outside the US';
  const currencyName = countryInfo?.currency || 'local currency';

  return (
    <>
      <SubtextHeader>You're shopping in {countryName}</SubtextHeader>
      <SubtextList>
        <li>
          <Link href='/entire-world'>International flat-rate</Link> shipping
        </li>
        <li>Prices shown in {currencyName}</li>
        <li>Final charges will be processed in USD</li>
      </SubtextList>
    </>
  );
};

interface InternationalCurrencyModalProps {
  location: string;
}

export const InternationalCurrencyModal = ({
  location,
}: InternationalCurrencyModalProps) => {
  const { countryCode } = useContext(LocationContext);
  const { experimentFlags } = useFeatureFlags();
  const isDisplayInternationalCurrency =
    experimentFlags[ExperimentFlag.DisplayInternationalCurrency];

  const [isIntlModalOpen, setIsIntlModalOpen] = useState<boolean>(
    isDisplayInternationalCurrency,
  );

  // hydration issue can happen if we don't wait for the client to render before displaying
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);

  const handleClickButton = () => {
    setIsIntlModalOpen(false);
    trackButtonEvent(
      'International Currency modal continue shopping button',
      location,
      {
        countryCode: countryCode,
      },
    );
  };

  // const handleClickClose = () => {
  //   setIsIntlModalOpen(false);
  //   trackButtonEvent(
  //     'International Currency modal close button',
  //     location,
  //     {
  //       countryCode: countryCode,
  //     },
  //   );
  // };

  useEffect(() => {
    if (isDisplayInternationalCurrency) {
      setIsIntlModalOpen(true);
    }
  }, [isDisplayInternationalCurrency]);

  return (
    <ModalWithButton
      isActive={isIntlModalOpen && isMounted}
      header={<Header>Welcome to Seed</Header>}
      subtext={<InternationalCurrencyModalSubtext />}
      buttonText='Continue Shopping'
      onButtonClick={handleClickButton}
      handleCloseModal={() => setIsIntlModalOpen(false)}
    />
  );
};
